module.exports = __webpack_public_path__ + "img/circle-checklist.75ffd2fe.svg";